export default {
  init() {

  },
  finalize() {
    if ($('.global-alert').length > 0) {
      var bannerHeight = 0;

      // Reduce height of banner if alert is visible
      if ($('.global-banner').length > 0) {
        bannerHeight = $('.global-banner').outerHeight();

        if ($('.global-banner').hasClass('banner-has-alert')) {
          const alertHeight = $('.global-alert').outerHeight();
          $('.global-banner').css({ 'height': (bannerHeight - alertHeight) + 'px' });
        }
      }

      $('.global-alert .alert-close').on('click', function() {
        $('.global-alert').stop().slideUp(200);

        const d = new Date();
        d.setTime(d.getTime() + (24 * 60 * 60 * 1000));

        document.cookie = `alert_closed=true; expires=${d.toUTCString()}; path=/`;

        // Set banner height to its original
        if (bannerHeight !== 0) {
          $('.global-banner').css({ 'height': bannerHeight + 'px' });
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/alert.js